import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useParams } from 'react-router';
import QueryRenderer from '../../../../../shared/relay/QueryRenderer';
import {
  withTableHistoryProvider,
  useTableHistoryQueryVariables
} from '../../../../../shared/contexts/tableHistoryContext';
import { PAGINATION_TYPES } from '../../../../../shared/constants';
import SolicitationReferenceList from './SolicitationReferenceList';

const SolicitationReferenceTab = () => {
  const variables = useTableHistoryQueryVariables();
  const { id } = useParams();

  return (
    <QueryRenderer
      query={graphql`
        query SolicitationReferenceTabQuery($id: ID!, $first: Int) {
          solicitation(id: $id) {
            ...SolicitationReferenceList_solicitation @arguments(first: $first)
          }
        }
      `}
      variables={{ id, ...variables }}
      render={relayProps => <SolicitationReferenceList solicitation={relayProps.solicitation} />}
    />
  );
};

export default withTableHistoryProvider(SolicitationReferenceTab, 'freSolicitationReferences', {
  rowsPerPage: PAGINATION_TYPES.short.defaultValue
});
